import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme as lexusTheme } from "../theme/lexusTheme";

export const Wrapper = styled.div`
    display: inline-block;
    position: relative;
    vertical-align: middle;
    @media ${getBreakpoint("down", "md")} {
        white-space: nowrap;
    }
`;

export const Tab = styled.button<{ isActive?: boolean; isSmall?: boolean }>`
    position: relative;
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: ${({ isSmall }) => (isSmall ? `30px` : `60px`)};
    margin-left: ${({ isSmall }) => (isSmall ? `12px` : `30px`)};
    padding: ${({ isSmall }) => (isSmall ? `0 0 3px` : `18px 20px 22px`)};
    font-family: ${lexusTheme.fonts.book};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    text-overflow: ellipsis;
    color: ${lexusTheme.colors.white};
    background-color: transparent;
    border: none;
    border-radius: 0;
    outline: 0;
    opacity: 0.4;
    overflow: hidden;

    ${({ theme }) =>
        theme.isRTL
            ? css`
                  &:last-child {
                      margin-right: 0;
                  }
              `
            : css`
                  &:first-child {
                      margin-left: 0;
                  }
              `}

    span {
        display: inline-block;
        line-height: 2rem;
    }

    &::after {
        display: none;
        position: absolute;
        bottom: 0px;
        left: 50%;
        width: 70%;
        height: 2px;
        content: "";
        background-color: ${lexusTheme.colors.white};
        transform: translateX(-50%);
        z-index: 1;
        @media ${getBreakpoint("up", "md")} {
            left: 0;
            width: 100%;
            transform: none;
        }
    }
    ${({ isActive }) =>
        isActive &&
        css`
            font-family: ${lexusTheme.fonts.book};
            color: ${lexusTheme.colors.white};
            background-color: transparent;
            border-radius: 0;
            opacity: 1;
            &::after {
                display: block;
                background-color: ${lexusTheme.colors.white};
            }
        `};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${({ isSmall }) => (isSmall ? `12px` : `30px`)};

        ${({ theme }) =>
            theme.isRTL
                ? css`
                      &:last-child {
                          margin-left: 0;
                      }
                  `
                : css`
                      &:first-child {
                          margin-right: 0;
                      }
                  `}
        &::after {
            left: auto;
            right: 50%;
            @media ${getBreakpoint("up", "md")} {
                left: auto;
                right: 0;
            }
        }
    }
`;
